module.exports = {
  decorateVDOMContent: vdom => vdom,
  decorateUniformValue: (value /* name, shader */) => value
};
